import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

// ESTE COMPONENTE FAZ COM QUE AO USAR UM <Link> OU history.push A PÁGINA ENCAMINHADA VOLTE PARA O COMEÇO DA TELA.
// ESTE COMPONENTE ESTÁ SENDO CHAMADO NO INDEX.JS DO PROJETO E DEVE FICAR APENAS LÁ
function ScrollToTop({ history }) {
	useEffect(() => {
		const unlisten = history.listen(() => {
			window.scrollTo(0, 0);
		});
		return () => {
			unlisten();
		};
	}, [history]);

	return null;
}

export default withRouter(ScrollToTop);
